<input type="hidden">
<div class="default text">{{placeholder}}</div>
<div *ngIf="range" class="dates">{{range}}</div>
<i class="dropdown icon"></i>
<div class="menu">
  <ng-container *ngFor="let item of items">
    <div *ngIf="item.optgroup" class="header">{{item.optgroup}}</div>
    <div
      [attr.data-value]="item.value"
      [ngClass]="item.class"
      class="item"
    >
      {{item.name}}
    </div>
  </ng-container>
</div>
